import React from "react";
import { Users, Award } from "lucide-react";

export const AlumniSection = () => {
  const alumni = [
    {
      name: "Shah Rukh Khan",
      image: "/images/shah-rukh-khan.webp",
      gradient: "from-blue-400 to-cyan-300",
    },
    {
      name: "Manoj Bajpayee",
      image: "/images/Manoj-Bajpayee.jpg",
      gradient: "from-purple-400 to-pink-300",
    },
    {
      name: "Rana Daggubati",
      image: "/images/rana-daggubati.jpg",
      gradient: "from-indigo-400 to-purple-300",
    },
    {
      name: "Varun Dhawan",
      image: "/images/varun-dhawan.jpg",
      gradient: "from-cyan-400 to-blue-300",
    },
    {
      name: "Dulquer Salmaan",
      image: "/images/dulquer-salmaan.jpg",
      gradient: "from-emerald-400 to-teal-300",
    },
    {
      name: "Arjun Kapoor",
      image: "/images/Arjun-kapoor.jpg",
      gradient: "from-red-400 to-orange-300",
    },
    {
      name: "Jacqueline Fernandez",
      image: "/images/jacqueline-fernandez.jpg",
      gradient: "from-fuchsia-400 to-pink-300",
    },
    {
      name: "Richa Chadha",
      image: "/images/richa-chadha.jpg",
      gradient: "from-pink-400 to-rose-300",
    },
    {
      name: "Freida Pinto",
      image: "/images/Freida-Pinto.jpg",
      gradient: "from-amber-400 to-yellow-300",
    },
    {
      name: "Dia Mirza",
      image: "/images/Dia-Mirza.jpg",
      gradient: "from-rose-400 to-pink-300",
    },
    {
      name: "Sushant Singh Rajput",
      image: "/images/ssr.avif",
      gradient: "from-blue-500 to-indigo-400",
    },
    {
      name: "Kunal Kapoor",
      image: "/images/Kunal-Kapoor.jpeg",
      gradient: "from-orange-400 to-amber-300",
    },
    {
      name: "Samir Soni",
      image: "/images/Samir-Soni.jpeg",
      gradient: "from-violet-400 to-purple-300",
    },
    {
      name: "Shiney Ahuja",
      image: "/images/shiney-ahuja.webp",
      gradient: "from-slate-400 to-gray-300",
    },
    {
      name: "Harshvardhan Rane",
      image: "/images/harshvardhan-rane.jpg",
      gradient: "from-teal-400 to-cyan-300",
    },
    {
      name: "Plabita Borthakur",
      image: "/images/plabita-borthakur.avif",
      gradient: "from-lime-400 to-green-300",
    },
  ];

  return (
    <section
      id="alumni"
      className="py-16 px-6 lg:px-8 bg-gradient-to-b from-purple-50 to-white"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 rounded-full mb-4">
            <Users className="w-4 h-4 text-purple-600" />
            <span className="text-sm font-semibold text-purple-700">
              Notable Alumni
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Join the Legacy of Bollywood's Finest
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Train with the same mentor who shaped the careers of India's most
            celebrated actors
          </p>
        </div>

        {/* Alumni Grid - Modern Card Style */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {alumni.map((person, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              {/* Gradient Background */}
              <div
                className={`absolute inset-0 bg-gradient-to-b ${person.gradient} opacity-90`}
              ></div>

              {/* Content */}
              <div className="relative h-full flex flex-col min-h-[300px] sm:min-h-[400px] lg:min-h-[450px]">
                {/* Main Image - Blends into gradient */}
                <div className="flex-1 relative -mt-4 -mb-16">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <img
                      src={person.image}
                      alt={person.name}
                      className="w-full h-full object-cover object-center scale-110 group-hover:scale-100 transition-transform duration-500"
                      style={{
                        maskImage:
                          "radial-gradient(ellipse 80% 100% at center, black 40%, transparent 100%)",
                        WebkitMaskImage:
                          "radial-gradient(ellipse 80% 100% at center, black 40%, transparent 100%)",
                      }}
                    />
                  </div>
                </div>

                {/* Name Section - Moved to bottom */}
                <div className="px-2 sm:px-4 lg:px-6 pt-3 pb-4 sm:pb-6 text-center z-10 relative">
                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/60 via-black/40 to-transparent"></div>
                  <h3 className="text-base sm:text-xl lg:text-3xl font-bold text-white mb-2 relative z-10 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
                    {person.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
